import { useState, useEffect } from "react";

const Logo = () => (
  <svg width="32" height="32" viewBox="0 0 36 36" fill="none">
    <rect width="36" height="36" rx="8" fill="white"/>
    <path d="M18 4L6 9V18C6 24.6 11.4 30.6 18 32C24.6 30.6 30 24.6 30 18V9L18 4Z" fill="#0052a3"/>
    <path d="M14 18L17 21L23 15" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function Navigation({ currentPage, setCurrentPage }) {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const links = [["home","Home"],["about","About"],["eligibility","Eligibility"],["apply","Apply"],["contact","Contact"]];
  const bottomLinks = [
    { id:"home", lbl:"Home", svg:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
    { id:"apply", lbl:"Apply", svg:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg> },
    { id:"login", lbl:"Login", svg:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
    { id:"contact", lbl:"Help", svg:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
  ];

  return (
    <>
      <nav style={{ background:"linear-gradient(135deg,#0052a3,#003d7a)", padding:"0 16px", position:"sticky", top:0, zIndex:1000, boxShadow:"0 2px 16px rgba(0,0,0,0.2)" }}>
        <div style={{ maxWidth:1200, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"space-between", height:58 }}>

          {/* Logo */}
          <div onClick={()=>{setCurrentPage("home");setOpen(false);}} style={{ display:"flex", alignItems:"center", gap:9, cursor:"pointer", flexShrink:0 }}>
            <Logo/>
            <div style={{ lineHeight:1.2 }}>
              <div style={{ color:"white", fontWeight:800, fontSize:14, whiteSpace:"nowrap" }}>Imalisha Welfare</div>
              <div style={{ color:"rgba(255,255,255,0.6)", fontSize:9, letterSpacing:"0.8px", textTransform:"uppercase" }}>Loan Programme</div>
            </div>
          </div>

          {/* Desktop nav */}
          {!isMobile && (
            <div style={{ display:"flex", gap:2 }}>
              {links.map(([id,lbl])=>(
                <button key={id} onClick={()=>setCurrentPage(id)} style={{ background:currentPage===id?"rgba(255,255,255,0.18)":"transparent", color:"white", border:"none", padding:"8px 14px", borderRadius:8, fontSize:13, fontWeight:currentPage===id?700:400, cursor:"pointer" }}>{lbl}</button>
              ))}
            </div>
          )}

          {/* Desktop CTA */}
          {!isMobile && (
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={()=>setCurrentPage("login")} style={{ background:"rgba(255,255,255,0.1)", color:"white", border:"1px solid rgba(255,255,255,0.3)", padding:"8px 18px", borderRadius:8, fontSize:13, fontWeight:600, cursor:"pointer" }}>Login</button>
              <button onClick={()=>setCurrentPage("apply")} style={{ background:"white", color:"#0052a3", border:"none", padding:"8px 20px", borderRadius:8, fontSize:13, fontWeight:700, cursor:"pointer" }}>Apply Now</button>
            </div>
          )}

          {/* Mobile right */}
          {isMobile && (
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <button onClick={()=>setCurrentPage("apply")} style={{ background:"white", color:"#0052a3", border:"none", padding:"7px 16px", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer" }}>Apply</button>
              <button onClick={()=>setOpen(!open)} style={{ background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", borderRadius:8, color:"white", cursor:"pointer", padding:0, width:36, height:36, display:"flex", flexDirection:"column", gap:5, justifyContent:"center", alignItems:"center" }}>
                <span style={{ display:"block", height:2, width:16, background:"white", borderRadius:2, transition:"all 0.3s", transform:open?"rotate(45deg) translate(0,7px)":"none" }}/>
                <span style={{ display:"block", height:2, width:16, background:"white", borderRadius:2, opacity:open?0:1, transition:"all 0.2s" }}/>
                <span style={{ display:"block", height:2, width:16, background:"white", borderRadius:2, transition:"all 0.3s", transform:open?"rotate(-45deg) translate(0,-7px)":"none" }}/>
              </button>
            </div>
          )}
        </div>

        {/* Mobile dropdown */}
        {open && isMobile && (
          <div style={{ background:"rgba(0,30,80,0.97)", borderTop:"1px solid rgba(255,255,255,0.1)", padding:"8px 0 16px" }}>
            {links.map(([id,lbl])=>(
              <button key={id} onClick={()=>{setCurrentPage(id);setOpen(false);}} style={{ display:"block", width:"100%", background:currentPage===id?"rgba(255,255,255,0.1)":"transparent", color:"white", border:"none", borderLeft:currentPage===id?"3px solid white":"3px solid transparent", padding:"13px 20px", textAlign:"left", fontSize:15, fontWeight:currentPage===id?700:400, cursor:"pointer" }}>{lbl}</button>
            ))}
            <div style={{ padding:"12px 20px 0", display:"flex", gap:10 }}>
              <button onClick={()=>{setCurrentPage("login");setOpen(false);}} style={{ flex:1, background:"rgba(255,255,255,0.1)", color:"white", border:"1px solid rgba(255,255,255,0.3)", padding:11, borderRadius:8, fontSize:14, fontWeight:600, cursor:"pointer" }}>Login</button>
              <button onClick={()=>{setCurrentPage("apply");setOpen(false);}} style={{ flex:1, background:"white", color:"#0052a3", border:"none", padding:11, borderRadius:8, fontSize:14, fontWeight:700, cursor:"pointer" }}>Apply Now</button>
            </div>
          </div>
        )}
      </nav>

      {/* Mobile bottom navigation - FIXED at bottom */}
      {isMobile && (
        <div style={{ position:"fixed", bottom:0, left:0, right:0, background:"white", borderTop:"1px solid #e2e8f0", padding:"6px 0 10px", zIndex:999, boxShadow:"0 -4px 20px rgba(0,0,0,0.08)", display:"flex", justifyContent:"space-around" }}>
          {bottomLinks.map(({id,lbl,svg})=>(
            <button key={id} onClick={()=>setCurrentPage(id)} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:3, background:"transparent", border:"none", cursor:"pointer", flex:1, padding:"2px 0", color:currentPage===id?"#0052a3":"#94a3b8" }}>
              <div style={{ width:36, height:36, background:currentPage===id?"#eff6ff":"transparent", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center" }}>
                {svg}
              </div>
              <span style={{ fontSize:10, fontWeight:currentPage===id?700:400 }}>{lbl}</span>
            </button>
          ))}
        </div>
      )}
    </>
  );
}

